import Tooltip from '@material-ui/core/Tooltip';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import Checkbox from '@material-ui/core/Checkbox';
import classnames from 'classnames';
import { tableIcons } from 'common/util/materialTable/materialTableIcons';
import { colorGrey3, colorBlue1 } from 'styles/_colors.scss';
import { theme, options} from 'common/util/materialTable';
import styles from '../containers/StudyPermissions.scss';

export const customTheme = {
    ...theme,
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontFamily: 'Hind',
                fontSize: '14px',
                fontWeight: 500,
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: '1.29'
            }
        },
        MuiPaper: {
            root: {
                ...theme.overrides.MuiPaper.root,
                width:'100%',
            }
        },
        MuiTable: {
            root: {
                width: '100%',
                margin: '0 auto 0 auto',
                border: '1px solid rgba(224, 224, 224, 1)',
            }
        },
        MuiTableCell: {
            ...theme.overrides.MuiTableCell,
            root : {
                padding: '0 !important',
                borderBottom: '1px solid rgba(200, 200, 200, 1)',
                borderLeft: '1px solid rgba(240, 240, 240, 1)',
                borderRight: '1px solid rgba(240, 240, 240, 1)',
                minHeight: '48px',
                height: '48px !important',
                lineHeight: '1'
            },
        },
    }
};

export const customOptions = {
    ...options,
    search: false,
    sorting: false,
    draggable: false,
    showTitle: false,
    toolbar:false,
    paging: false,
    headerStyle: {
        backgroundColor: colorGrey3,
    }
};

export const getColumns = (columns, activeColumnId, isEditing, editTable, toggleCheckbox) => {
    return columns.map(({ field, title, tooltip, isEditable, type, id }) => ({
        id,
        field,
        type,
        title: (
            <div className = {styles.header} data-cy="utils">
                <div className = {styles.helperText}>
                    <div data-cy="utils-title">{title}</div>
                    {tooltip ? <Tooltip title={tooltip} placement="right-end" interactive>
                        <i className={styles.icon}/>
                    </Tooltip> : null}
                </div>
                {isEditable && (!isEditing) ? <EditOutlinedIcon style={{color: colorBlue1, cursor:'pointer'}} onClick={() => { editTable(id);} }/> : null}
            </div>
        ),
        render: (rowData) => {
            if(typeof rowData[field] === 'boolean') {
                if(isEditing && activeColumnId === id && rowData.editable){
                    return <div className={classnames(styles.check, styles.fadeBlue)}
                        onClick={() => {toggleCheckbox(field, rowData.id);}} data-cy="utils-toggleCheckbox">
                        <Checkbox
                            defaultChecked={rowData[field]}
                            style={{color: colorBlue1}}
                            disableRipple
                        />
                    </div>;
                }
                const fieldClassnames = isEditing && activeColumnId === id
                    ? classnames(styles.check, styles.fadeBlue)
                    : styles.check;
                return <h1 className={fieldClassnames} data-cy="utils-h1">
                    { rowData[field] ? <tableIcons.Check style={{color: colorBlue1}}/> : ''}
                </h1>;
            }
            if(rowData.tooltip)
                return <div className={styles.rowHelperText} data-cy="utils-div">
                    {rowData[field]}
                    <Tooltip title={rowData.tooltip} placement="right-end" interactive>
                        <i className={styles.icon}/>
                    </Tooltip>
                </div>;
            return <h1 className={styles.rowHelperText} data-cy="utils-rowHelperText">{rowData[field]}</h1>;
        },        
    }));
};
